export default "__VITE_ASSET__DkFJWL6i__"